export default {
  data() {
    return {
      subjectVO: {},
      videoBg: require("@/assets/images/supplier/video-bg.png"),
    };
  },
  mounted() {
    this.subjectVO = JSON.parse(localStorage.getItem("subjectVO"));
  },
  methods: {
    // 为了保持弹窗的统一性，这里还是用了layer，主要看项目别处已经用过了，也已经引入了jq
    openModal() {
      const that = this;
      window.layer.open({
        type: 1,
        skin: "ss-popup",
        id: "download-guide-popup",
        content: `<div class="popup-wrapper">
                    <div class="popup-title">
                      <div class="close-btn" onClick="window.layer.closeAll()">
                        <i class="iconfont icon-guanbi2"></i>
                      </div>
                    </div>
                    <div class="popup-content">
                      <div class="left-area">
                        <div class="title">产销对接-神农直采</div>
                        <div class="desc">
                          查看更多采购商、联系采购商，请扫码下载“<span class="app-name"></span>”APP使用完整功能
                        </div>
                        <div class="code-pic hidden">
                          <img
                            class="qr"
                            src=""
                            alt=""
                          />
                        </div>
                      </div>
                      <div class="right-area"><img class="video-bg" src="" alt=""></div>
                    </div>
                  </div>`,
        title: false,
        area: ["800px", "560px"],
        btn: false,
        closeBtn: 0,
        success: function () {
          const productName = that.subjectVO.productName || "神农口袋";
          $("#download-guide-popup .app-name").text(productName);

          if (that.subjectVO.appDownloadPhotoUrl) {
            $("#download-guide-popup .code-pic").removeClass("hidden");
            $("#download-guide-popup .code-pic .qr").attr(
              "src",
              that.subjectVO.appDownloadPhotoUrl
            );
          } else {
            $("#download-guide-popup .code-pic").addClass("hidden");
          }

          $("#download-guide-popup .right-area .video-bg")
            .attr("src", that.videoBg)
            .on("click", function () {
              that.openVideo();
            });
        },
      });
    },
    openVideo() {
      window.layer.open({
        type: 1,
        skin: "ss-popup video",
        id: "video-pop",
        content: `<div style="position:relative;width: 1000px;height: 570px;display:flex;justify-content:center;align-items:center;background: #000">
          <video style="width: 100%;height: 100%" autoplay="autoplay" controls="controls">
            <source src="https://snkoudai.oss-cn-hangzhou.aliyuncs.com/common/source/zhicai-introduce.mp4" type="video/mp4"/>
          </video>
        </div>`,
        title: false,
        area: ["1000px", "570px"],
        btn: false,
        closeBtn: 1,
      });
    },
  },
};
